<div class="input-wrapper">
  <app-upload-shapefile
    #dbfFile
    [requestId]="requestId"
    [displayConfig]="{
      showTitle: true,
      showDescription: false,
      customTitle: 'Efetuar o upload do histórico de safras (.dbf)',
      titlePosition: 'above',
      titleBold: false,
      customDescriptionUpload:
        'Clique aqui ou arraste arquivo do histórico de safras (.dbf) para fazer upload',
    }"
    (fileUploaded)="onFileUploadedDbf($event)"
    [acceptFile]="dbfFileTypes"
  ></app-upload-shapefile>

  <app-upload-shapefile
    #fgbFile
    [displayConfig]="{
      showTitle: true,
      showDescription: false,
      customTitle: 'Efetuar o upload do Uso do Solo (.fgb)',
      titlePosition: 'above',
      titleBold: false,
      customDescriptionUpload:
        'Clique aqui ou arraste arquivo do Uso do Solo (flatgeobuf *.fgb) para fazer upload',
    }"
    (fileUploaded)="onFileUploadedFgb($event)"
    [acceptFile]="fgbFileTypes"
    [requestId]="requestId"
  ></app-upload-shapefile>
</div>
<hr />

<div class="button-group">
  <button mat-stroked-button color="primary" (click)="onCancel()">
    <mat-icon>arrow_back</mat-icon>Cancelar
  </button>
  <button
    mat-flat-button
    [disabled]="isLoading() | async"
    color="primary"
    (click)="onSubmit()"
  >
    Concluir

    @if (isLoading() | async) {
      <mat-icon>
        <mat-spinner matIcon diameter="18"></mat-spinner>
      </mat-icon>
    } @else {
      <mat-icon>save</mat-icon>
    }
  </button>
</div>
